export enum LoadedTrackingEventsEnum {
    LOAD = 'dsCheckout_load',
    OPEN = 'dsCheckout_open',
    CLOSE = 'dsCheckout_close',
    VIEW_PRODUCT_SELECTION_OPEN = 'dsCheckout_view_productSelection_open',
    VIEW_PRODUCT_SELECTION_CLOSE = 'dsCheckout_view_productSelection_close',
    VIEW_PRODUCT_ADDONS_OPEN = 'dsCheckout_view_productAddons_open',
    VIEW_PRODUCT_ADDONS_CLOSE = 'dsCheckout_view_productAddons_close',
    VIEW_SHOPPING_CART_OPEN = 'dsCheckout_view_shoppingCart_open',
    VIEW_SHOPPING_CART_CLOSE = 'dsCheckout_view_shoppingCart_close',
    VIEW_LOGIN_SUGGESTION_OPEN = 'dsCheckout_view_loginSuggestion_open',
    VIEW_LOGIN_SUGGESTION_CLOSE = 'dsCheckout_view_loginSuggestion_close',
    VIEW_CONTACT_INFO_OPEN = 'dsCheckout_view_contactInfo_open',
    VIEW_CONTACT_INFO_CLOSE = 'dsCheckout_view_contactInfo_close',
    VIEW_PERSON_PERSONALIZATION_OPEN = 'dsCheckout_view_personPersonalization_open',
    VIEW_PERSON_PERSONALIZATION_CLOSE = 'dsCheckout_view_personPersonalization_close',
    VIEW_OVERVIEW_OPEN = 'dsCheckout_view_overview_open',
    VIEW_OVERVIEW_CLOSE = 'dsCheckout_view_overview_close',
    VIEW_PAYMENT_OPEN = 'dsCheckout_view_payment_open',
    VIEW_PAYMENT_CLOSE = 'dsCheckout_view_payment_close',
    VIEW_CONFIRMATION_OPEN = 'dsCheckout_view_confirmation_open',
    VIEW_CONFIRMATION_CLOSE = 'dsCheckout_view_confirmation_close',
    VIEW_PROGRESSBAR_OPEN = 'dsCheckout_view_progressBar_open',
    VIEW_PROGRESSBAR_CLOSE = 'dsCheckout_view_progressBar_close',
    VIEW_PROGRESSBAR_STEP_LABEL = 'dsCheckout_view_progressBar_step_label',
}